import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [isConsultationOpen, setIsConsultationOpen] = useState(false);

    const openConsultation = () => setIsConsultationOpen(true);
    const closeConsultation = () => setIsConsultationOpen(false);

    return (
        <ModalContext.Provider value={{ isConsultationOpen, openConsultation, closeConsultation }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
